import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const setSubgroup = (id, data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.GROUP_MANAGEMENT.SET_SUBGROUP(id),
    data
  );
};

export default setSubgroup;
